/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { IRootPathSelectorFacade } from '../../../../../data-access/src/lib/domain/facades-models/root-path-selector-facade-interface';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';
import { Store } from '@ngrx/store';
import { ToolBeltState } from '../tool-belt.reducer';
import { RootpathService } from '../../../../../utils/src/lib/rootpath.service';
import { selectRootPath } from '../tool-belt.selector';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RootPathSelectorFacade implements IRootPathSelectorFacade {
  constructor(
    public messageHandler: DotNetRequestMessageService,
    private store: Store<ToolBeltState>,
    public rootPathService: RootpathService
  ) {}

  initializeRootPath() {
    return this.store.select(selectRootPath);
  }

  setRootPath(rootPathValue: string): void {
    this.rootPathService.setRootPathChange(rootPathValue);
  }

  selectRootPath(): Observable<string> {
    return from<Promise<string>>(this.messageHandler.sendRequestAsync('SelectRootPath'));
  }
}
